import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import LazyLoad from 'react-lazyload'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const Facilities = () => {
    useEffect(() => {
        document.title = 'Facilities-  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li> 
<li>  About Us  </li> 
     <li> Facilities </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1> Facilities  </h1>
         </div>
     </div>
     <div className="row sports"> 
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
            <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/LIBRARY.jpg">
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/LIBRARY.jpg" className="img-fluid" alt="STPCSH"/>
                    <p>LIBRARY</p>
                </a>
            </LazyLoad>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
            <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/ART & CRAFT ROOM.jpg">
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/ART & CRAFT ROOM.jpg" className="img-fluid" alt="STPCSH"/>
                    <p>ART & CRAFT ROOM</p>
            </a>
            </LazyLoad>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
            <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/SOCIAL STUDIES LAB.jpg">
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/SOCIAL STUDIES LAB.jpg" className="img-fluid" alt="STPCSH"/>
                    <p>SOCIAL STUDIES LAB</p>
            </a>
            </LazyLoad>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
            <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/MATHEMATICS LAB.jpg">
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/MATHEMATICS LAB.jpg" className="img-fluid" alt="STPCSH"/>
                    <p>MATHEMATICS LAB</p>
            </a>
            </LazyLoad>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
            <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/CHEMISTRY LAB.jpg">
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/CHEMISTRY LAB.jpg" className="img-fluid" alt="STPCSH"/>
                    <p>CHEMISTRY LAB</p>
            </a>
            </LazyLoad>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
            <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/AUDITORIUM.jpg">
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/AUDITORIUM.jpg" className="img-fluid" alt="STPCSH"/>
                    <p>AUDITORIUM</p>
            </a>
            </LazyLoad>
            </div> 
            </div>

  </div>
</div>
<Footer/>
    </>
  )
}

export default Facilities
